import {Router} from '@multipass-system';
import {EventBus} from 'esp-js';

import {NavigateRequestedEvent, NavigationEvents, PageActivatedEvent} from './events';
import {NavigationStoreModel} from './navigationStoreModel';

export const NAVIGATION_STORE_ID = 'navigation-store';

export const registerNavigationStore = (eventBus: EventBus, router: Router) => {
    eventBus.storeBuilder<NavigationStoreModel>(NAVIGATION_STORE_ID, new NavigationStoreModel())
        .withEventHandler<PageActivatedEvent>(NavigationEvents.pageActivated, (draft, event) => {
            draft.onPageActivated(event.page);
        })
        .withEffect<NavigateRequestedEvent>(NavigationEvents.navigateRequested, (model, event) => {
            router.navigate(event.path);
        })
        .build();
};
